export enum ButtonType {
    Primary = 'primary',
    Secondary = 'secondary',
    Tertiery = 'tertiery',
}
